import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_ESTADOS } from 'store/modules/api/estados.actions'

const lista = (state = [], { type, payload }) => (
  (type === API_LISTAR_ESTADOS.success) ? payload : state
)

const isCarregandoLista = loadingReducer(false, API_LISTAR_ESTADOS)

export default combineReducers({
  lista,
  isCarregandoLista,
})
